import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import type {
	Experiments,
	IPageResourceFetcher } from '@wix/thunderbolt-symbols'
import {
	ExperimentsSymbol,
	PageResourceFetcherSymbol,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type { TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { name as tpaCommonsName } from 'feature-tpa-commons'
import type { IRoutingLinkUtilsAPI } from 'feature-router'
import { RoutingLinkUtilsAPISymbol } from 'feature-router'
import type { ILightboxUtils } from 'feature-lightbox'
import { LightboxUtilsSymbol } from 'feature-lightbox'
import type { IMultilingualLinkUtilsAPI } from 'feature-multilingual'
import { MultilingualLinkUtilsAPISymbol } from 'feature-multilingual'
import type { ICustomUrlMapper } from 'feature-custom-url-mapper'
import { CustomUrlMapperSymbol } from 'feature-custom-url-mapper'
import { getSiteMap } from './utils/siteMap'
import type { ISiteMap } from './types'

export const SiteMap = withDependencies(
	[
		named(SiteFeatureConfigSymbol, tpaCommonsName),
		RoutingLinkUtilsAPISymbol,
		PageResourceFetcherSymbol,
		ExperimentsSymbol,
		optional(LightboxUtilsSymbol),
		optional(MultilingualLinkUtilsAPISymbol),
		optional(CustomUrlMapperSymbol),
	],
	(
		tpaCommonsSiteConfig: TpaCommonsSiteConfig,
		routingLinkUtilsAPI: IRoutingLinkUtilsAPI,
		pageResourceFetcher: IPageResourceFetcher,
		experiments: Experiments,
		lightboxUtils: ILightboxUtils,
		multilingualLinkUtilsAPI?: IMultilingualLinkUtilsAPI,
		customUrlMapper?: ICustomUrlMapper
	): ISiteMap => ({
		getSiteMap: async () => {
			const siteMapItems = await pageResourceFetcher.fetchResource('masterPage', 'siteMap')
			return getSiteMap(
				siteMapItems,
				tpaCommonsSiteConfig,
				routingLinkUtilsAPI,
				lightboxUtils,
				experiments,
				multilingualLinkUtilsAPI,
				customUrlMapper
			)
		},
	})
)
